export default __webpack_public_path__ + "static/media/ic_check_circle.1fd2bb40.svg";